import { createClient } from '@/shared/api/client'
import { validateResponseHasSchema } from '@/shared/api/validation'
import { z } from 'zod'
import { TargetSystem } from '@/shared/constants'
import { buildUrl } from '@/shared/utils/urls'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export async function fetchUploadedFile (id: string) {
  const parsed = await validateResponseHasSchema(
    client.sendGet(`uploads/${id}`),
    z.object({
      data: z.object({
        id: z.string(),
        fileName: z.string(),
        size: z.number(),
      })
    })
  )

  return {
    ...parsed.data,
    downloadUrl: client.buildUrl(`uploads/${id}/contents`).toString()
  }
}
